import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";

import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";

import { getData, getDateString } from "../utils";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";

import Modal from "react-modal";
import Toolbar from "../elements/CalendarToolbar";

const localizer = momentLocalizer(moment);

const loaderOverride = css`
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  z-index: 11;
`;

class FullCalendar extends React.Component {
  state = {
    events: [],
    eventListStart: "",
    eventListEnd: "",
    loadEventList: false,
    loadAttempts: 0,
    loadCalendar: false,
    showModal: false,
    modalData: {},
  };

  handleOpenModal(modalData) {
    this.setState({ ...this.state, showModal: true, modalData });
  }

  handleCloseModal() {
    this.setState({ ...this.state, showModal: false, modalData: null });
  }

  checkCalendarItemsLoaded() {
    if (
      document.querySelector("div.rbc-event") === null &&
      this.state.loadAttempts < 60
    ) {
      setTimeout(() => {
        this.checkCalendarItemsLoaded();
      }, 100);

      this.setState({
        loadAttempts: this.state.loadAttempts + 1,
      });
    } else {
      this.setState({
        loadCalendar: true,
      });
    }
  }

  async loadData() {
    const today = new Date();

    const data = (
      await getData(
        [],
        {},
        {
          showDeleted: false,
          timeMin: getDateString(new Date(today.getFullYear(), 0, 1)),
          timeMax: getDateString(new Date(today.getFullYear(), 11, 1), false),
        }
      )
    ).data;
    this.setState({
      events: data.map((event) => ({
        id: event.id,
        title: event.summary,
        start: moment(event.start.dateTime).toDate(),
        end: moment(event.end.dateTime).toDate(),
      })),
    });
  }

  async componentDidMount() {
    await this.loadData();
    this.checkCalendarItemsLoaded();

    this.setState({
      loadEventList: true,
    });
  }

  render() {
    return (
      <div className="calendarContainer">
        {this.state.loadCalendar === false && (
          <div className="pageObscure">
            <FadeLoader css={loaderOverride} size={300} />
          </div>
        )}
        {this.state.events && (
          <Calendar
            localizer={localizer}
            events={this.state.events}
            defaultView={Views.MONTH}
            views={["month"]}
            messages={{ previous: "Previous Month", next: "Next Month" }}
            popup
            selectable
            onSelectEvent={(event) => this.handleOpenModal(event)}
            style={{ height: "100vh" }}
            components={{ toolbar: Toolbar }}
          />
        )}
        <Modal
          isOpen={this.state.showModal}
          onRequestClose={() => this.handleCloseModal()}
          shouldCloseOnOverlayClick={true}
        >
          <div class="modalButton">
            <button onClick={() => this.handleCloseModal()}>X</button>
          </div>
          <div class="modalContent">
            {this.state.modalData && (
              <>
                <p class="modalContent__Title">{this.state.modalData.title}</p>
                {`${moment(this.state.modalData.start).format(
                  "dddd, MMMM Do h:mma"
                )} - ${moment(this.state.modalData.end).format("h:mma")}`}
              </>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default FullCalendar;
